/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Visit_BodyInputs */

const en_price_page_visit_body = /** @type {(inputs: Price_Page_Visit_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every trainer, dietician and physio has their own price list, shown on their page before you book anything.`)
};

const pl_price_page_visit_body = /** @type {(inputs: Price_Page_Visit_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każdy trener, dietetyk i fizjoterapeuta ma swój cennik, widoczny na jego stronie, zanim cokolwiek zarezerwujesz.`)
};

/**
* | output |
* | --- |
* | "Every trainer, dietician and physio has their own price list, shown on their page before you book anything." |
*
* @param {Price_Page_Visit_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_visit_body = /** @type {((inputs?: Price_Page_Visit_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Visit_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_visit_body(inputs)
	return en_price_page_visit_body(inputs)
});